import { Clear, Search } from '@mui/icons-material';
import { Avatar, CardHeader, Divider, IconButton, InputBase } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { FunctionComponent, useState } from 'react';

type SimpleSearchProps = {
  setSearch: (searchValue: string) => void;
  placeholder: string;
};

const SimpleSearch: FunctionComponent<SimpleSearchProps> = (props: SimpleSearchProps) => {
  const [searchValue, setSearchValue] = useState('');
  const theme = useTheme();
  const updateValue = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newValue = event.target.value.toLowerCase();
    setSearchValue(newValue);
    props.setSearch(newValue);
  };

  const handleKeySubmit = (event?: React.KeyboardEvent) => {
    if (event && event.key && event.key !== 'Enter') {
      return;
    }
    props.setSearch(searchValue);
  };

  const handleClickSubmit = () => props.setSearch(searchValue);

  const clearState = () => {
    setSearchValue('');
    props.setSearch('');
  };

  return (
    <>
      <CardHeader
        title={
          <InputBase
            id={'search-field'}
            onKeyPress={handleKeySubmit}
            onChange={updateValue}
            placeholder={props.placeholder}
            value={searchValue}
            fullWidth
          />
        }
        avatar={
          <Avatar sx={{ marginTop: -theme.spacing(), backgroundColor: theme.palette.primary.main }}>
            <Search />
          </Avatar>
        }
        action={
          searchValue ? (
            <IconButton onClick={clearState} size="large">
              <Clear />
            </IconButton>
          ) : (
            <IconButton onClick={handleClickSubmit} size="large">
              <Search />
            </IconButton>
          )
        }
        sx={{ padding: theme.spacing() }}
      />
      <Divider />
    </>
  );
};

export default SimpleSearch;
